import { stripeId } from './StripeStore';

export const updateStripeId = (value) => stripeId.update(oldValue => value);
